const downloadApp = () => {
  var iOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
  var appiOSUrlScheme = "onmoapp://ios";

  var appStoreURL = "https://apps.apple.com/gb/app/onmo";
  var AndroidStoreURL =
    "https://play.google.com/store/apps/details?id=app.onmo.v2&gl=UK";

  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
  var appAndroidUrlScheme = "onmoapp://android";

  var weblink = "/";
  let loadedAt;
  if (iOS) {
    //If the app is not installed the script will wait for 2sec and redirect to web.
    alert(appiOSUrlScheme);
    loadedAt = +new Date();
    setTimeout(function () {
      if (+new Date() - loadedAt < 2000) {
        window.location = appStoreURL;
      }
    }, 25);
    //Try launching the app using URL schemes
    window.open(appiOSUrlScheme, "_self");
  } else if (isAndroid) {
    alert(appAndroidUrlScheme);
    //If the app is not installed the script will wait for 2sec and redirect to web.
    loadedAt = +new Date();
    setTimeout(function () {
      if (+new Date() - loadedAt < 2000) {
        window.location = AndroidStoreURL;
      }
    }, 25);
    //Try launching the app using URL schemes
    window.open(appAndroidUrlScheme, "_self");
  } else {
    //Launch the website
    window.location = weblink;
  }
};

export default downloadApp;
